import {Component, Input} from '@angular/core';
import { PricingContextDto } from '../../domain/map/chargeAreaDetailsMarker';
import {finalize} from 'rxjs/operators';
import {NewChargeContext} from '../../services/business/newChargeContext.service';
import {Observable} from 'rxjs';
import {compact, find, isEmpty} from 'lodash-es';

@Component({
    selector: 'new-charge-summary',
    templateUrl: './newChargeSummary.component.html',
    styleUrls: ['./newChargeSummary.component.scss']
})
export class NewChargeSummaryComponent {
    @Input() set newChargeContext(newChargeContext: NewChargeContext) {
        this._newChargeContext = newChargeContext;
    }

    @Input() set pricingContextObs(pricingContextObs: Observable<PricingContextDto>) {
        this.updatePricingContext(pricingContextObs);
    }

    @Input() public defaultPricingContext: PricingContextDto;
    public pricingContext: PricingContextDto;
    public hasPricingInfo: boolean = false;
    public ghostPricing: boolean = true;

    private _newChargeContext: NewChargeContext;

    get newChargeContext(): NewChargeContext {
        return this._newChargeContext;
    }

    private _pricingContextObs: Observable<PricingContextDto>;

    get pricingContextObs(): Observable<PricingContextDto> {
        return this._pricingContextObs;
    }

    private computeHasPricingInfo(pricingContext: PricingContextDto): boolean {
        return pricingContext
            && pricingContext.pricingCodesBySubscriptionRef
            && Object.keys(pricingContext.pricingCodesBySubscriptionRef).length > 0
            && (Object.keys(pricingContext.pricingCodesBySubscriptionRef).length > 1
                || !!find(Object.values(pricingContext.pricingCodesBySubscriptionRef), (item) => !isEmpty(compact(item))));
    }

    private updatePricingContext(value: Observable<PricingContextDto>) {
        this._pricingContextObs = value;

        if (this._pricingContextObs) {
            this.ghostPricing = true;
            this.pricingContext = this.buildGhostPricingContext();
            this._pricingContextObs
                .pipe(finalize(() => this.ghostPricing = false))
                .subscribe(
                    pricingInfos => {
                        this.pricingContext = pricingInfos;
                        this.hasPricingInfo = this.computeHasPricingInfo(pricingInfos);
                    },
                    () => {
                        this.pricingContext = this.defaultPricingContext;
                        this.hasPricingInfo = this.computeHasPricingInfo(this.defaultPricingContext);
                    }
                );
        } else {
            this.hasPricingInfo = false;
        }
    }

    private buildGhostPricingContext() {
        return {
            pricingCodesBySubscriptionRef: {
                '1': [' ']
            },
            subscriptionNameByRef: {
                '1': ' '
            }
        };
    }
}
